import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import Home from './components/Home'
import Hello from './components/Hello'
import Test from './components/Test'
import PlannersTable from './components/PlannersTable'
import Main from './components/Main'
import CRVHome from './components/CRVHome'
import DialogMasterList from './components/main-page-modules/DialogMasterList.vue'
// import Maintenance from './components/Maintenance'


//> Master Routes
import TileColors from './components/master/TileColors'
import HouseTypes from './components/master/HouseTypes'
import HouseTypeCategories from './components/master/HouseTypeCategories'
import Entrance from './components/master/EntranceDoor'
import RoofSelection from './components/master/RoofSelection'
import ColorSelectionLayout from './components/master/ColorSelectionLayout'
import SashType from './components/master/SashType'
import SashReinforcement from './components/master/SashReinforcement'
import SashAccessories from './components/master/SashAccessories'
import SashSelection from './components/master/SashSelection'
import SprayItems from './components/master/SprayItems'
import SprayLenaRack from './components/master/SprayLenaRack'
import SprayShipoStones from './components/master/SprayShipoStones'
import SpraySynagio from './components/master/SpraySynagio'
import BalconyBeltMakeupTiles from './components/master/BalconyBeltMakeupTiles'
import EavesSelections from './components/master/EavesSelections'
import GableSelections from './components/master/GableSelections'
import Siporoks from './components/master/Siporoks'
import ViewDirections from './components/master/ViewDirections'
import ViewHeights from './components/master/ViewHeights'
import CombDesigns from './components/master/CombDesigns'
import LouverItems from './components/master/LouverItems'
import LouverWoods from './components/master/LouverWoods'
import LouverPaints from './components/master/LouverPaints'
import SmileCubeStairs from './components/master/SmileCubeStairs'
import JikuStairs from './components/master/JikuStairs'
import KitchenSets from './components/master/KitchenSets'
import SmileKitchenSets from './components/master/SmileKitchenSets'
import GrandKitchenSets from './components/master/GrandKitchenSets'
import SmartKitchenCounters from './components/master/SmartKitchenCounters'
import GrandKitchenCounters from './components/master/GrandKitchenCounters'
import Slitsliders from './components/master/Slitsliders'
import StonePatterns from './components/master/StonePatterns'
import HangingClosetLattices from './components/master/HangingClosetLattices'
import BaseDrainers from './components/master/BaseDrainers'
import MoldingSelection from './components/master/MoldingSelection'
import FanovaEntranceDoor from './components/master/FanovaEntranceDoor'
import FireproofFanova from './components/master/FireproofFanova'
import Pronova from './components/master/PronovaDoor'
import FeatureColorSelection from './components/master/FeatureColorSelection'
import JoineryColorSelection from './components/master/JoineryColorSelection'
import SmartFlooringSelection from './components/master/SmartFlooringSelection'
import SmileFlooringSelection from './components/master/SmileFlooringSelection'
import CubeFlooring from './components/master/CubeFlooring'
import JikuFlooring from './components/master/JikuFlooring'
import GrandFlooring from './components/master/GrandFlooring'
import SmartGrandStair from './components/master/SmartGrandStair'
import AriNashi from './components/master/AriNashi'
import TileCombination from './components/master/TileCombination'
import Remarks from './components/master/Remarks'
import HouseTypeRemarks from './components/master/HouseTypeRemarks'
import EntranceDoor from './components/master/EntranceDoor'
import PorchColor from './components/master/PorchColor'
import PorchTile from './components/master/PorchTile'
import LatticeSliding from './components/master/LatticeSlidingDoor'
import HouseTypeGroup from './components/master/HouseTypeGroup'
import EavesGutterSelections from './components/master/EavesGutterSelections'
import KanabakariSettings from './components/master/KanabakariSetting'
import FloorLayout from './components/master/FloorLayout'
import ColorPersColumn from './components/master/ColorPersColumn'
import TileExternal from './components/master/TileExternal'
import PlannerMaster from './components/master/PlannerMaster'
import Sample from './components/Sample'

import FlooringSelection from './components/master/FlooringSelections'
import KitchenCounter from './components/master/KitchenCounters'
import HpStair from './components/master/HpStairs'
import Tatami from './components/master/Tatami'

import Logs from './components/main-page-modules/DialogSystemVersion.vue'
import FeedBack from './components/main-page-modules/DialogFeedBack.vue'
import Notice from './components/main-page-modules/DialogNotice.vue'

import CADExcel from './components/master/CadExcel.vue'
import CADManual from './components/master/CadManual.vue'
import Sekou from './components/master/Sekou.vue'

import HPColumns from './components/master/HpColumns.vue'
import BossCode from './components/master/BossCodes.vue'

import HRDCalendar from './components/master/HRDCalendar.vue'

import store from './store';


// export default
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            // redirect: '/cadrequest'
            redirect: '/home'
        },

        {
            // path: '/main',
            path: '/cadrequest',
            name: 'main',
            component: Main
        },
        // {
        //     path: '/Maintenance',
        //     name: 'Maintenance',
        //     component: Maintenance
        // },
        {
            path: '/home',
            // path: '/cadrequest',
            name: 'CRVHome',
            component: CRVHome
        },
        {
            path: '/masterlist',
            name: 'masterlist',
            component: DialogMasterList
        },
        {
            path: '/logs',
            name: 'logs',
            component: Logs
        },
        {
            path: '/feedBack',
            name: 'feedBack',
            component: FeedBack
        },
        {
            path: '/notice',
            name: 'notice',
            component: Notice
        },
        {
            // path: '/home',
            path: '/viewtable',
            name: 'home',
            component: Home
        },
        {
            path: '/hello',
            name: 'hello',
            component: Hello
        },

        {
            path: '/test',
            name: 'test',
            component : Test
        },

        {
            path: '/entrance',
            name: 'entrance',
            component : Entrance
        },

        {
            path: '/planners_table',
            name: 'planners_table',
            component : PlannersTable
        },

        // Master Routes 

        {
            path: '/master_settings/hrd_calendar',
            name: 'hrd_calendar',
            component : HRDCalendar
        },

        {
            path: '/master_settings/boss_codes',
            name: 'boss_codes',
            component : BossCode
        },

        {
            path: '/master_settings/tile_colors',
            name: 'tile_colors',
            component : TileColors
        },

        {
            path: '/master_settings/house_types',
            name: 'house_types',
            component : HouseTypes
        }, 

        {
            path: '/master_settings/house_type_categories',
            name: 'house_type_categories',
            component : HouseTypeCategories
        },

        
        {
            path: '/master_settings/roof_selection',
            name: 'roof_selection',
            component : RoofSelection
        },

        {
            path: '/master_settings/color_selection_layout',
            name: 'color_selection_layout',
            component : ColorSelectionLayout
        },

        {
            path: '/master_settings/sash_type',
            name: 'sash_type',
            component : SashType
        },

        {
            path: '/master_settings/spray_lena',
            name: 'spray_lena',
            component : SprayLenaRack
        },

        {
            path: '/master_settings/synagio',
            name: 'synagio',
            component : SpraySynagio
        },

        {
            path: '/master_settings/sash_reinforcement',
            name: 'sash_reinforcement',
            component : SashReinforcement
        },

        {
            path: '/master_settings/sash_accessories',
            name: 'sash_accessories',
            component : SashAccessories
        },

        {
            path: '/master_settings/sash_selection',
            name: 'sash_selection',
            component : SashSelection
        },

        {
            path: '/master_settings/spray_items',
            name: 'spray_items',
            component : SprayItems
        },

        {
            path: '/master_settings/spray_shipo',
            name: 'spray_shipo',
            component : SprayShipoStones
        },

        {
            path: '/master_settings/balcony_belt_makeup_tiles',
            name: 'balcony_belt_makeup_tiles',
            component : BalconyBeltMakeupTiles
        },

        {
            path: '/master_settings/eaves_selections',
            name: 'eaves_selections',
            component : EavesSelections
        },

        {
            path: '/master_settings/eaves_gutter_selections',
            name: 'eaves_gutter_selections',
            component: EavesGutterSelections
        },

        {
            path: '/master_settings/gable_selections',
            name: 'gable_selections',
            component : GableSelections
        },

        {
            path: '/master_settings/siporoks',
            name: 'siporoks',
            component : Siporoks
        },

        {
            path: '/master_settings/view_direction_selections',
            name: 'view_direction_selections',
            component : ViewDirections
        },

        {
            path: '/master_settings/view_height_selections',
            name: 'view_height_selections',
            component : ViewHeights
        },

        {
            path: '/master_settings/comb_designs',
            name: 'comb_designs',
            component : CombDesigns
        },

        {
            path: '/master_settings/louver_items',
            name: 'louver_items',
            component : LouverItems
        },

        {
            path: '/master_settings/louver_woods',
            name: 'louver_woods',
            component : LouverWoods
        },

        {
            path: '/master_settings/louver_paints',
            name: 'louver_paints',
            component : LouverPaints
        },

        {
            path: '/master_settings/smile_cube_stairs',
            name: 'smile_cube_stairs',
            component : SmileCubeStairs
        },

        {
            path: '/master_settings/jiku_stairs',
            name: 'jiku_stairs',
            component : JikuStairs
        },

        {
            path: '/master_settings/kitchen_sets',
            name: 'kitchen_sets',
            component : KitchenSets
        },

        {
            path: '/master_settings/smile_kitchen_sets',
            name: 'smile_kitchen_sets',
            component : SmileKitchenSets
        },

        {
            path: '/master_settings/grand_kitchen_sets',
            name: 'grand_kitchen_sets',
            component : GrandKitchenSets
        },

        {
            path: '/master_settings/smart_kitchen_counters',
            name: 'smart_kitchen_counters',
            component : SmartKitchenCounters
        },

        {
            path: '/master_settings/grand_kitchen_counters',
            name: 'grand_kitchen_counters',
            component : GrandKitchenCounters
        },

        {
            path: '/master_settings/slit_sliders',
            name: 'slit_sliders',
            component : Slitsliders
        },

        {
            path: '/master_settings/stone_patterns',
            name: 'stone_patterns',
            component : StonePatterns
        },

        {
            path: '/master_settings/hanging_closet_lattices',
            name: 'hanging_closet_lattices',
            component : HangingClosetLattices
        },

        {
            path: '/master_settings/molding_selection',
            name: 'molding_selection',
            component : MoldingSelection
        },

        {
            path: '/master_settings/fanova_entrance',
            name: 'fanova_entrance',
            component : FanovaEntranceDoor
        },

        {
            path: '/master_settings/fireproof_fanovas',
            name: 'fireproof_fanovas',
            component : FireproofFanova
        },

        {
            path: '/master_settings/pronova_door',
            name: 'pronova_door',
            component : Pronova
        },

        {
            path: '/master_settings/feature_color',
            name: 'feature_color',
            component : FeatureColorSelection
        },

        {
            path: '/master_settings/joinery_color_selection',
            name: 'joinery_color_selection',
            component : JoineryColorSelection
        },

        {
            path: '/master_settings/smart_flooring_selection',
            name: 'smart_flooring_selection',
            component : SmartFlooringSelection
        },

        {
            path: '/master_settings/smile_flooring_selection',
            name: 'smile_flooring_selection',
            component : SmileFlooringSelection
        },

        {
            path: '/master_settings/cube_flooring_selection',
            name: 'cube_flooring_selection',
            component : CubeFlooring
        },

        {
            path: '/master_settings/jiku_flooring_selection',
            name: 'jiku_flooring_selection',
            component : JikuFlooring
        },

        {
            path: '/master_settings/grand_flooring_selection',
            name: 'grand_flooring_selection',
            component : GrandFlooring
        },

        {
            path: '/master_settings/smart_grand_stair',
            name: 'smart_grand_stair',
            component : SmartGrandStair
        },

        {
            path: '/master_settings/ari_nashi',
            name: 'ari_nashi',
            component : AriNashi
        },

        {
            path: '/master_settings/base_drainers',
            name: 'base_drainers',
            component : BaseDrainers
        },

        {
            path: '/master_settings/tile_combinations',
            name: 'tile_combinations',
            component : TileCombination
        },
        {
            path: '/master_settings/remarks',
            name: 'remarks',
            component : Remarks
        },
        {
            path: '/master_settings/house_type_remarks',
            name: 'house_type_remarks',
            component : HouseTypeRemarks
        },
        {
            path: '/master_settings/entrance_door',
            name: 'entrance_door',
            component : Entrance
        },
        {
            path: '/master_settings/porch_colors',
            name: 'porch_colors',
            component : PorchColor
        },
        {
            path: '/master_settings/porch_tiles',
            name: 'porch_tiles',
            component : PorchTile
        },

        {
            path: '/master_settings/lattice_sliding',
            name: 'lattice_sliding',
            component : LatticeSliding
        },


        {
            path: '/master_settings/house_type_group',
            name: 'house_type_group',
            component : HouseTypeGroup
        },


        {
            path: '/master_settings/flooring_selections',
            name: 'flooring_selections',
            component : FlooringSelection
        },

        {
            path: '/master_settings/kitchen_counters',
            name: 'kitchen_counters',
            component : KitchenCounter
        },

        {
            path: '/master_settings/hp_stairs',
            name: 'hp_stairs',
            component : HpStair
        },
        {
            path: '/master_settings/tatami',
            name: 'tatami',
            component : Tatami
        },
        {
            path: '/master_settings/kanabakari_settings',
            name: 'kanabakari_settings',
            component : KanabakariSettings
        },

        {
            path: '/master_settings/cad_excel',
            name: 'cad_excel',
            component : CADExcel
        },

        {
            path: '/master_settings/cad_manual',
            name: 'cad_manual',
            component : CADManual
        },

        {
            path: '/master_settings/sekou',
            name: 'sekou',
            component : Sekou
        },

        {
            path: '/master_settings/hp_columns',
            name: 'hp_columns',
            component : HPColumns
        },

        // {
        //     path: '/master_settings/floor_layout',
        //     name: 'floor_layout',
        //     component: FloorLayout
        // },

        {
            path: '/master_settings/color_pers_column',
            name: 'color_pers_column',
            component : ColorPersColumn
        },
        
        {
            path: '/master_settings/tile_external',
            name: 'tile_external',
            component : TileExternal
        },

        {
            path: '/master_settings/planner_master',
            name: 'planner_master',
            component : PlannerMaster
        },

        {
            path: '/sample',
            name: 'sample',
            component : Sample
        },
    ],
});


// HRD VIEWER ROUTE NAVIGATION
router.beforeEach((to, from, next) => {
    const loggedInUser = store.state.loggedInUser

    if(loggedInUser.is_hrd_viewer === 1 && to.path !== '/viewtable' && to.path !== '/home' && to.path !== '/logs' && to.path !== '/feedBack'){
        next('/viewtable')
    } else {
        store.commit('SET_EXISTING_REVISIONS', [])
        store.state.cadRequestBasicInformation = {}
        store.commit('setCadRequestBasicInformation', {})
        store.state.authorityResponse = null
        store.state.getXml = null
        store.state.cadRequestLatestRevision = null
        next();
    }
})


export default router